import NewsItem from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/NewsFeed/NewsItem";
import NewsFeedItemForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/NewsFeedItemForm";
import { Button } from "@/components/ui"
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react"

const NewsFeedGroup = () => {
    const { templatePayload:data } = useMicroSiteContext();
    const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
  
  const [showForm, setShowForm] = useState(false);
  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <div className="grid md:grid-cols-2 md:gap-8 gap-6 w-full">
      {data.newsFeedSection.newsFeedSectionDetails.map((item, index) => (
           // Item index is passed to help identify which item is being deleted because multiple items can have the same content and there is no unique id
        <NewsItem key={index} data={item} itemIndex={index} />
      ))}
    </div>

    {showForm && (
       <NewsFeedItemForm setShowForm={setShowForm} />
    )}

   {isEdit && <div className="mt-12">
      <Button className="bg-forestGreen-200 lg:max-w-[50%] w-full border border-dashed !border-forestGreen-100 !text-forestGreen-100 hover:!text-white" onClick={()=>{
        setShowForm(true)
      }} >Add News Feed Section</Button>
    </div>}
    </div>
    
  )
}

export default NewsFeedGroup